module.exports = __webpack_public_path__ + "img/logo_main.64a8f7a0.png";